<MainSidebar :use-slide="useSlide" :compact-mode="compactMode" :fixed-slide="fixedSlide"></MainSidebar>